<template>
  <button class="button903 border-0">
    <slot>button</slot>
  </button>

</template>

<script>
export default {
  name: "Button903",
  components: {},
}
</script>

<style scoped>
.button903 {
  position: fixed;
  right: 50px;
  bottom: 80px;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
}


</style>